import * as React from "react"

const ScaleBiz = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 259.88 283.6" {...props}>
    <title>{"Grow-Your-Business-Shipx-2"}</title>
    <path
      d="m64 198.7 59.4-34.7a3.61 3.61 0 0 1 5.44 3.11v28.39l53.93-31.5a3.61 3.61 0 0 1 5.43 3.11v28.39l12.54-7.33 2.91-103.4a3.62 3.62 0 0 1 3.61-3.51H225a3.62 3.62 0 0 1 3.61 3.51l2.39 85.8 11.12-6.49a3.6 3.6 0 0 1 5.43 3.11v112.67a3.62 3.62 0 0 1-3.61 3.62H65.86a3.62 3.62 0 0 1-3.61-3.62V201.8a3.62 3.62 0 0 1 1.75-3.1Z"
      fill="#007f6e"
    />
    <path
      d="m2.51 164.72 83.25-48.63a5.06 5.06 0 0 1 7.62 4.37v39.8L169 116.09a5.07 5.07 0 0 1 7.62 4.37v39.8L194.21 150 198.3 4.92A5.07 5.07 0 0 1 203.37 0h24.85a5.06 5.06 0 0 1 5.06 4.92l3.39 120.28 15.59-9.11a5.07 5.07 0 0 1 7.62 4.37v158.08a5.07 5.07 0 0 1-5.06 5.06H5.07A5.07 5.07 0 0 1 0 278.55V169.09a5.07 5.07 0 0 1 2.51-4.37Z"
      fill="#007f6e"
    />
    <path
      d="m64 198.7 59.4-34.7a3.61 3.61 0 0 1 5.44 3.11v28.39l53.93-31.5a3.61 3.61 0 0 1 5.43 3.11v28.39l12.54-7.33 2.91-103.4a3.62 3.62 0 0 1 3.61-3.51H225a3.62 3.62 0 0 1 3.61 3.51l2.39 85.8 11.12-6.49a3.6 3.6 0 0 1 5.43 3.11v112.67a3.62 3.62 0 0 1-3.61 3.62H65.86a3.62 3.62 0 0 1-3.61-3.62V201.8a3.62 3.62 0 0 1 1.75-3.1Z"
      fill="#00b08e"
    />
    <path
      d="m110.74 224.61 41.2-24.09a2.52 2.52 0 0 1 3.44.89 2.61 2.61 0 0 1 .34 1.28v19.71l37.46-21.88a2.52 2.52 0 0 1 3.78 2.17v19.71l8.71-5.08 2-71.87a2.51 2.51 0 0 1 2.51-2.44h12.31a2.51 2.51 0 0 1 2.51 2.44l1.68 59.55 7.72-4.51a2.5 2.5 0 0 1 3.43.9 2.45 2.45 0 0 1 .35 1.27V281a2.51 2.51 0 0 1-2.51 2.51H112a2.51 2.51 0 0 1-2.5-2.51v-54.2a2.49 2.49 0 0 1 1.24-2.19Z"
      fill="#b1da00"
    />
    <rect
      x={127.17}
      y={244.51}
      width={21.9}
      height={14.67}
      rx={2.51}
      fill="#fff"
    />
    <rect
      x={162.92}
      y={244.51}
      width={21.89}
      height={14.67}
      rx={2.51}
      fill="#fff"
    />
    <rect
      x={198.66}
      y={244.51}
      width={21.9}
      height={14.67}
      rx={2.51}
      fill="#fff"
    />
  </svg>
)

export default ScaleBiz
